import * as React from 'react'
import styles from './Divider.module.scss'

const Divider: React.FunctionComponent = () => <hr className={styles.root} />

export default Divider
